module.exports = __webpack_public_path__ + "static/media/392JamesPBrawleyDrNW_2018-06-12_165.7e210cc0.jpg";